import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { isEmpty } from "lodash";

import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "../MyAccount/MyAccountFilter";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { levelMap, toFixedWithoutRounding } from "../../Utils/Constant";

const plSpan = (value) =>
  Math.sign(value) === -1 ? (
    <span className="loss-text">
      ({toFixedWithoutRounding(value)})
    </span>
  ) : (
    <span>{toFixedWithoutRounding(value)}</span>
  );

const DownlineRow = ({ item, depth, filter }) => {
  const playerPL = Number(item?.stake?.amount || 0);
  const commission = Number(item?.stake?.commission || 0);
  const isUser = item?.userType === "user";

  const [open, setOpen] = useState(false);
  const [children, setChildren] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const toggle = async () => {
    if (open) {
      setOpen(false);
      return;
    }
    setOpen(true);
    if (loaded) return;

    const { status, data: response_users } = await apiGet(
      apiPath.reportParlayDownline,
      {
        page: 1,
        limit: filter.limit,
        fromPeriod: filter.fromPeriod,
        toPeriod: filter.toPeriod,
        filterByDay: filter.filterByDay,
        created_by: item?._id,
        userType: item?.userType,
      },
    );
    if (status === 200 && response_users.success) {
      setChildren(response_users.results?.data || []);
    }
    setLoaded(true);
  };

  return (
    <>
      <tr
        id="table_DL"
        className={
          depth === 1
            ? "ng-star-inserted"
            : `expand expand_${depth} ng-star-inserted`
        }
      >
        <td className="align-L">
          {!isUser && (
            <a
              id="_bySport"
              className={open ? "expand-close" : "expand-open"}
              style={{ cursor: "pointer" }}
              onClick={toggle}
            />
          )}
          <a id="_userName" className="ico_account">
            <span className={`Bdlevel ${levelMap[item?.userType]}`} />
            {item?.username}{" "}
          </a>
        </td>
        <td id="_profitLoss">
          <div className="ng-star-inserted">{plSpan(playerPL)}</div>
        </td>
        <td>
          <div className="ng-star-inserted">{plSpan(playerPL)}</div>
        </td>
        <td id="_tax2">
          <div className="ng-star-inserted">
            <span>{toFixedWithoutRounding(commission)}</span>
          </div>
        </td>
        <td id="_profitLossUpLine">
          <div className="ng-star-inserted">{plSpan(-playerPL)}</div>
        </td>
      </tr>

      {open &&
        children.map((child, i) => (
          <DownlineRow
            key={child?._id || `${depth}-${i}`}
            item={child}
            depth={depth + 1}
            filter={filter}
          />
        ))}
    </>
  );
};

const ReportByParlayDownline = () => {
  const tableRef = useRef();

  const previousDate = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
  });

  const [data, setData] = useState([]);
  const [sumData, setSumData] = useState({});

  const getData = async (activeFilter) => {
    const path = apiPath.reportParlayDownline;
    const { status, data: response_users } = await apiGet(path, activeFilter);
    if (status === 200 && response_users.success) {
         setData(
        response_users.results?.data?.filter((res) => {
          return Math.abs(res?.stake?.amount) > 0;
        }) || [],
      );
      setSumData(response_users.results?.sumData || {});
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);

  const applyPreset = (preset) => {
    const nextFilter = { ...filter, page: 1, filterByDay: preset };
    if (preset === "today") {
      nextFilter.fromPeriod = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    } else if (preset === "yesterday") {
      nextFilter.fromPeriod = moment()
        .subtract(1, "day")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment()
        .subtract(1, "day")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));

  const totalRecords = data?.length || 0;

  return (
    <app-pl-downline className="ng-star-inserted">
      <div className="main_wrap">
        <div className="box">
          <h2>Profit/Loss Report by parlay Downline</h2>
        </div>

        <ul className="report-tab-wrap">
          <li
            id="reportType_exchange"
            data-reporttabtype={0}
            className="report-tab select"
          >
            <a>Exchange</a>
          </li>
        </ul>

        <div className="function-wrap">
          <ul className="input-list flowroot">
            <li>
              <label>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
          </ul>
          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>

        <div id="noReportMessage" />

        <div id="userTreeDiv" className="total_all">
          <span className="spacer" />
          <span>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              className="ng-star-inserted"
              value={filter.limit}
              onChange={handleLimitChange}
            >
               <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
            </select>
          </span>
          <span className="total-users" style={{ fontWeight: "600" }}>
            Total Records: {totalRecords}{" "}
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="report-parlay-downline"
          />
        </div>

        <div
          id="reportDiv"
          className="over-wrap ng-star-inserted"
          style={{ maxHeight: "calc(100% - 32px - 93px - 55px)" }}
        >
          <div className="table-responsive data-table">
            <table ref={tableRef} id="table_DL" className="table01 table-pt">
              <tbody>
                <tr id="table_DL">
                  <th
                    id="header_userName"
                    width="15%"
                    className="align-L sort_asc"
                  >
                    UID
                  </th>
                  <th width="20%" className="sort_asc">
                    Player P/L{" "}
                  </th>
                  <th
                    id="header_profitLoss_downLine"
                    width="13%"
                    className="sort_asc"
                  >
                    {" "}
                    Downline P/L{" "}
                  </th>
                  <th id="header_tax_agent_2" width="10%" className="sort_asc">
                    Agent Comm.
                  </th>
                  <th width="15%" className="sort_asc">
                    Upline P/L{" "}
                  </th>
                </tr>
              </tbody>

              <tbody id="content">
                {!isEmpty(data) ? (
                  data.map((item, index) => (
                    <DownlineRow
                      key={item?._id || index}
                      item={item}
                      depth={1}
                      filter={filter}
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>You have no bets in this time period.</td>
                  </tr>
                )}

                {!isEmpty(data) && (
                  <tr className="total">
                    <td className="align-L">Total</td>
                    <td>
                      <div className="ng-star-inserted">
                        {plSpan(sumData?.PlayerPL || 0)}
                      </div>
                    </td>
                    <td id="_totalDownlinePl">
                      <span
                        className={
                          Math.sign(sumData?.PlayerPL) === -1 ? "red" : ""
                        }
                      >
                        {toFixedWithoutRounding(
                          sumData?.PlayerPL || 0,
                        )}
                      </span>
                    </td>
                    <td id="_totalComm">
                      <span>
                        {toFixedWithoutRounding(sumData?.commission || 0)}
                      </span>
                    </td>
                    <td id="_totalUplinePL">
                      <span>
                        {toFixedWithoutRounding(-(sumData?.PlayerPL || 0))}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </app-pl-downline>
  );
};

export default ReportByParlayDownline;
